<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Add Training Courses to ' + employee.FirstName + ' '+employee.LastName+' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees`">
                            <i class="fa fa-group"></i> Employees
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/view/${employee.EmployeeId}`">
                            {{ employee.FirstName }} {{ employee.LastName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-edit"></i> Add Course(s)
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">Add Courses</div>
                        <div class="card-body">

                            <div class="form-group row">
                                <label class="col-md-2 col-12 col-form-label text-sm-right text-muted">
                                    Employee:
                                </label>
                                <div class="col-md-10 col-sm-12 pt-2">
                                    <span v-if="employee.EmployeeNumber">{{ employee.EmployeeNumber }} - </span>{{ employee.FirstName }} {{ employee.LastName }}
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.completed_at }" class="row">
                                <label class="col-md-2 col-12 col-form-label text-sm-right text-muted">
                                    Courses:
                                </label>
                                <div class="col-md-10 col-sm-12">

                                    <table class="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Course <i class="fa fa-asterisk text-danger"></i></th>
                                                <th style="min-width: 100px;">Pending <i class="fa fa-question-circle" title="Pending Courses will remove the Completed & Expiration Date and set the course as pending completion."></i></th>
                                                <th>Date Completed</th>
                                                <th>Date Expires</th>
                                                <th class="text-center"><i class="fa fa-trash text-danger"></i></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(course, i) in empCourses">
                                                <td>
                                                    <b-form-select v-model="course.training_course_id" :options="courseOptions" :class="{'is-invalid': errors['courses.'+i+'.training_course_id']}" v-on:change="setExpiration(i)"></b-form-select>

                                                    <div class="text-danger" v-if="errors['courses.'+i+'.training_course_id']">
                                                        <span v-for="error in errors['courses.'+i+'.training_course_id']">{{ error }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <b-form-checkbox v-model="course.is_pending" :value="true" :unchecked-value="false" plain v-on:change="setPending(i)"></b-form-checkbox>
                                                </td>
                                                <td>
                                                    <date-picker v-model="course.completed_at" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors['courses.'+i+'.completed_at'] }" placeholder="Course Date" @dp-change="completedChanged($data, i)"></date-picker>

                                                    <div class="text-danger"  v-if="errors['courses.'+i+'.completed_at']">
                                                        <span v-for="error in errors['courses.'+i+'.completed_at']">{{ error }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <date-picker v-model="course.expires_at" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors['courses.'+i+'.expires_at'] }" placeholder="Expire Date"></date-picker>

                                                    <div class="text-danger"  v-if="errors['courses.'+i+'.expires_at']">
                                                        <span v-for="error in errors['courses.'+i+'.expires_at']">{{ error }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-link" v-on:click="deleteCourse(i)">
                                                        <i class="fa fa-trash text-danger"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" class="text-center">
                                                    <button class="btn btn-link" v-on:click="addCourse()"><i class="fa fa-plus-circle text-success"></i> Add Course</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveCourses()" :disabled="saving">
                Add Courses
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                employeeId: this.$route.params.employeeId,
                employee: {},
                courses: [],
                empCourses: [],
                errors: {},
            }
        },

        computed: {
            courseOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Training Course --'}];

                //Loop and Build
                for(var i = 0; i < this.courses.length; i++)
                {
                    options.push({value: this.courses[i].id, text: this.courses[i].course_name + (this.courses[i].valid_days ? ' (Good For '+this.courses[i].valid_days+' Days)' : '')});
                }

                //Send it
                return options;
            },
        },

        watch: {

        },

        methods: {

            addCourse(){
                //Setup Now
                var now = new Date();

                //Setup
                this.empCourses.push({
                    training_course_id: null,
                    completed_at: (now.getMonth() + 1)+'/'+now.getDate()+'/'+now.getFullYear(),
                    expires_at: null,
                });
            },

            completedChanged ( data, i ) {
                //Set it
                this.setExpiration(i);
            },

            setPending(i){
                //Get the course
                var empCourse = this.empCourses[i];

                //Clear Both
                empCourse.completed_at = null;
                empCourse.expires_at = null;
            },

            setExpiration(i){
                //Get the empCourse
                var empCourse = this.empCourses[i];

                //Checks
                if(!empCourse.training_course_id || !empCourse.completed_at)
                {
                    return;
                }

                //Setup
                var valid_days = null;

                //Loop and Check
                for(var j = 0; j < this.courses.length; j++)
                {
                    //Check ID
                    if(this.courses[j].id == empCourse.training_course_id)
                    {
                        valid_days = this.courses[j].valid_days;
                    }
                }

                //Check
                if(!valid_days)
                {
                    return;
                }

                //Set it
                var completed_date = new Date(empCourse.completed_at)
                var expire_date = new Date(empCourse.completed_at);

                //Set the Date
                expire_date.setDate(completed_date.getDate() + valid_days);

                //Format and set
                empCourse.expires_at = (expire_date.getMonth() + 1)+'/'+expire_date.getDate()+'/'+expire_date.getFullYear();
            },

            deleteCourse(i){
                //SPlice
                this.empCourses.splice(i, 1);
            },

            getData() {
                //Get the data
                this.$http
                    .get('/training-courses/employee/'+this.employeeId+ '/courses')
                    .then(response => {
                        //Set all the data
                        this.employee = response.data.employee;
                        this.courses = response.data.courses;

                        //Add
                        this.addCourse();
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            saveCourses() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('/training-courses/employee/'+this.employeeId+ '/courses', {courses: this.empCourses})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Training Courses Added');

                    //Check it
                    this.$router.push('/employees/view/' + this.employeeId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            useSuggestedExpiration(){
                //Set it
                this.empCourse.expires_at = this.suggestedExpirationDate;

                //Force update
                this.$forceUpdate();
            },
        },

        mounted() {
            //Get the Training Course
            this.getData();
        }
    }
</script>
